module.exports = __webpack_public_path__ + "static/img/emotions.12a674c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emotions.png
// module id = HRdQ
// module chunks = 0